import React from 'react';
import { useTheme } from 'styled-components';
import { Box, NotificationSuccessIcon } from 'edenred-ui';

import { IOnboardingStep } from '@epi-models/components/IOnboardingStep';

import { StepCircle } from './OnboardingStep.styles';

const OnboardingStep = ({
  isDone,
  isActive = false,
  label,
  stepNumber
}: IOnboardingStep) => {
  const theme = useTheme();

  const getStepColor = (isDone: boolean, isActive: boolean) => {
    if (isDone) return theme.positiveColor;
    if (isActive) return theme.primaryFrontColor;
    return theme.gray25;
  };

  return (
    <Box display={'flex'}>
      {isDone ? (
        <NotificationSuccessIcon width={32} />
      ) : (
        <StepCircle color={getStepColor(isDone, isActive)}>
          {stepNumber}
        </StepCircle>
      )}
      <Box
        pt={0.6}
        pl={1}
        fontSize={theme.sizeMedium}
        fontWeight={(isActive || isDone) && theme.fontSemiBold}
      >
        {label}
      </Box>
    </Box>
  );
};

export default OnboardingStep;
